import React, { useEffect } from "react";
import { Account, AppConfiguration, useAppDispatch, useAppSelector, useBulkDownloadFiles, Helpers, BrowserType } from "src/common";
import { DownloadProgress } from "../drive/drive-manager";
import { uiActions } from "src/store";
import { RootState } from "src/store/configureStore";
import streamSaver from "streamsaver";

const is_app = AppConfiguration.buildForApp();

function DownloadManagerComponent(props: { current_account: Account }) {
  const { current_account } = props;
  const dispatch = useAppDispatch();
  const download_request = useAppSelector((state: RootState) => state.drive.download_request);
  const upload_request = useAppSelector((state: RootState) => state.drive.upload_request);
  const download_progress_hidden = useAppSelector((state: RootState) => state.ui.download_progress_hidden);
  const { downloadFiles, progress } = useBulkDownloadFiles(current_account, is_app);

  useEffect(() => {
    // NOTE: Configure StreamSaver (service worker + mitm page)
    if (typeof window !== "undefined" && AppConfiguration.buildForWeb() && Helpers.getBrowser() !== BrowserType.firefox) {
      // NOTE: This must point to the mitm.html you copied into public/streamsaver
      streamSaver.mitm = `${window.location.origin}/streamsaver/mitm.html`;
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker
          .register("/streamsaver/sw.js", { scope: "/streamsaver/" })
          .catch((error) => {
            console.error("StreamSaver service worker registration failed", error);
          });
      }
    }
    // NOTE: Destroy service worker on onload of the component
    return () => {
      unregisterStreamSaverServiceWorker();
    };
  }, []);

  useEffect(() => {
    if (!!download_request) {
      downloadFiles(download_request);
    }
    // Description: Set Dirty Warning based on upload_progress_hidden
    dispatch(uiActions.handleSetDirtyMessage(!!download_request || !!upload_request));
  }, [download_request]);

  // Description: Destroy the service worker
  async function unregisterStreamSaverServiceWorker(): Promise<void> {
    if ("serviceWorker" in navigator) {
      const registration = await navigator.serviceWorker.getRegistration("/streamsaver/");
      await registration?.unregister();
    }
  }

  return <>
    {
      !download_progress_hidden &&
      <DownloadProgress progress={progress} />
    }
  </>;
}

export default React.memo(DownloadManagerComponent);
